import { useState } from "react";
import { Checkbox, CircularProgress } from "@mui/material";
import { useUpdateRecord } from "../../api/useUpdateRecord";
import { useTaskNotificationsRead } from "./useTaskNotificationsRead";
import { MarkNotificationsReadDialog } from "./MarkNotificationsReadDialog";

type TaskDoneShortcutWithNotificationsProps = {
	id: number;
	status: string;
	onStatusChange?: () => void;
};

export const TaskDoneShortcutWithNotifications = ({ id, status, onStatusChange }: TaskDoneShortcutWithNotificationsProps) => {
	const [checked, setChecked] = useState(status === "done");
	const [pendingChecked, setPendingChecked] = useState<boolean | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const mutation = useUpdateRecord();
	const { dialogProps, checkAndPrompt } = useTaskNotificationsRead(id);

	const updateTaskStatus = async (newChecked: boolean) => {
		await mutation.mutateAsync({
			entity: "tasks",
			id: id,
			data: { status: newChecked ? "done" : "open" }
		});
		setChecked(newChecked);
		onStatusChange?.();
	};

	const handleChange = async (newChecked: boolean) => {
		setIsLoading(true);
		const hasNotifications = await checkAndPrompt();
		setIsLoading(false);

		if (hasNotifications) {
			setPendingChecked(newChecked);
		} else {
			await updateTaskStatus(newChecked);
		}
	};

	const handleDialogConfirm = async () => {
		await dialogProps.onConfirm();
		if (pendingChecked !== null) {
			await updateTaskStatus(pendingChecked);
			setPendingChecked(null);
		}
	};

	const handleDialogCancel = () => {
		dialogProps.onCancel();
		setPendingChecked(null);
	};

	if (isLoading || mutation.isLoading) {
		return <CircularProgress size={24} sx={{ m: "9px" }} />;
	}

	return (
		<>
			<Checkbox checked={checked} onClick={(e) => e.stopPropagation()} onChange={(e) => handleChange(e.target.checked)} />
			<MarkNotificationsReadDialog {...dialogProps} onConfirm={handleDialogConfirm} onCancel={handleDialogCancel} />
		</>
	);
};
